import React from 'react';
import { Link } from 'react-router-dom';
import { Plus, Wallet } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/Card';
import { Button } from '../ui/Button';
import { useWallet } from '../../context/WalletContext';
import { formatMoney } from '../../utils/formatMoney';

export function YikiWalletPanel({ usageHint = 'แทงยี่กีหักจากยอดกระเป๋าเว็บไซต์ · ฝาก-ถอนที่หน้ากระเป๋าเงิน' }) {
  const { balance } = useWallet();

  return (
    <Card className="border-2 border-brand-gold/40">
      <CardHeader className="bg-brand-gold-light/20">
        <CardTitle className="flex items-center gap-2 text-base text-brand-red">
          <Wallet className="h-5 w-5 text-brand-gold" />
          กระเป๋า Mungkorn
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="rounded-xl border-2 border-brand-gold bg-gradient-to-br from-brand-gold-light/40 to-white p-4 text-center">
          <p className="text-sm text-gray-600">ยอดคงเหลือ (ใช้ร่วมกับลอตเตอรี่)</p>
          <p className="mt-1 text-2xl font-bold text-brand-gold">
            {formatMoney(balance)}
          </p>
        </div>

        <p className="text-center text-xs text-gray-500">
          {usageHint}
        </p>

        <Link to="/wallet" className="block">
          <Button variant="gold" className="w-full" size="sm">
            <Plus className="h-4 w-4" />
            ฝาก-ถอนเงิน
          </Button>
        </Link>
      </CardContent>
    </Card>
  );
}
